import { render, staticRenderFns } from "./MenuSubmenu.vue?vue&type=template&id=26a32d16&scoped=true"
import script from "./MenuSubmenu.vue?vue&type=script&lang=js"
export * from "./MenuSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a32d16",
  null
  
)

export default component.exports